type MicroManifest = {
  scope: string,
  module: string,
  mainFile: string,
  [mainFile: string]: string
}

type MicroInfo = {
  manifest?: MicroManifest,
  module?: any
}

function loadManifest(url: string): Promise<MicroManifest> {
  return fetch(url, {
    headers: { 'Content-Type': 'application/json' }
  }).then((response) => response.json())
}

function loadScript (src: string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}

export async function loadMicro (id: string, baseUrl: string) {
  // @ts-expect-error: global variable
  const micro = window[`TOPBAR_MICRO_${id}`] = window[`TOPBAR_MICRO_${id}`] || {} as MicroInfo
  if (micro.module) return micro.module
  // Load manifest
  if (!micro.manifest) {
    micro.manifest = await loadManifest(`${baseUrl}/manifest.json`)
    const scriptUrl = micro.manifest[micro.manifest.mainFile]
    await loadScript(scriptUrl)
  }
  // Initializes the share scope. This fills it with known provided modules from this build and all remotes
  // @ts-expect-error: "__webpack_init_sharing__" is a webpack global method
  await __webpack_init_sharing__('default')
  // Initialize the container, it may provide shared modules
  // @ts-expect-error: global variable
  const container = window[micro.manifest.scope]
  // @ts-expect-error: "__webpack_share_scopes__" is a webpack global const
  await container.init(__webpack_share_scopes__.default)
  // Get module
  const factory = await container.get(micro.manifest.module)
  micro.module = factory()
  return micro.module
}
